// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1IS-5","content":"LoadingAlert_content__2QxSS"};